import { RouteConfig } from "vue-router";

export enum VignetteVisibility {
  WEB_USER_ONLY, // visible to web users only (not ip users)
  MEMBER_ONLY, // visible to Vignette members, or NJ members with Vignette access
  // NJ_MEMBER_ONLY, // visible to NJ member without Vignette access
  PUBLIC_ONLY, // visible to anonymous users
  ALL, // visible to all users
}

interface VignetteRouteConfigBase {
  label: string;
  icon: string;
  visibility: VignetteVisibility;
  excludedFromNavBar: boolean;
  sortOrder: number;
}

export type VignetteRouteConfig = VignetteRouteConfigBase & RouteConfig;
